import React from 'react';
import Link from 'next/link';
import Image from 'next/image';

const HeroSection = ({ 
  title = "Transform InDesign Into a High Performance Production Engine",
  subtitle = "Most automated-personalization tools force designers to use clunky web editors. Personalia offers Industrial‑grade automation for personalized PDFs and images, powered by your existing InDesign workflow.",
  imageUrl,
  primaryCTA = { text: "Try it yourself", href: "#live-demo" },
  secondaryCTAs = [
    { text: "Explore Integrations", href: "/integrations" }
  ]
}) => {
  return (
    <section className="hero relative overflow-hidden" id="hero">
      <div className="container-custom relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="text-center lg:text-left">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
              {title}
            </h1>
            <p className="text-xl text-gray-300 mb-8 max-w-lg mx-auto lg:mx-0">
              {subtitle}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              {primaryCTA && (
                <Link href={primaryCTA.href} className="btn btn-primary">
                  {primaryCTA.text}
                </Link>
              )}
              {secondaryCTAs && secondaryCTAs.map((cta, index) => (
                <Link 
                  key={index} 
                  href={cta.href} 
                  className="btn btn-outline border-white text-white hover:bg-white hover:text-gray-900"
                >
                  {cta.text}
                </Link>
              ))}
            </div>
          </div>
          <div className="relative h-64 md:h-96 lg:h-[500px] rounded-lg overflow-hidden">
            <video
              autoPlay
              loop
              muted
              playsInline
              className="absolute top-0 left-0 w-full h-full object-cover z-0"
              src="/images/video/herovideo.mp4"
            >
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 w-full z-0">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 120" preserveAspectRatio="none" className="w-full h-auto">
          <path fill="#ffffff" d="M0,64L80,69.3C160,75,320,85,480,80C640,75,800,53,960,48C1120,43,1280,53,1360,58.7L1440,64L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path>
        </svg>
      </div>
    </section>
  );
};

export default HeroSection;
